import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppRoutes, PartnerInfo, PartnersService } from '@core';
import { SzBrandBlockComponent, SzIconComponent, SzPartnerCardComponent } from '@ui';

@Component({
  selector: 'app-partners-page',
  templateUrl: './partners.page.html',
  styleUrls: ['./partners.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, SzBrandBlockComponent, SzIconComponent, SzPartnerCardComponent]
})
export class PartnersPage {
  private readonly router: Router = inject(Router);
  private readonly partners: PartnersService = inject(PartnersService);

  readonly list: ReadonlyArray<PartnerInfo> = this.partners.list;

  goBack(): void {
    void this.router.navigateByUrl('/');
  }

  goToPartner(id: string): void {
    void this.router.navigateByUrl(`/${AppRoutes.PARTNERS}/${id}`);
  }
}
